{
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {},
      "geometry": {
        "coordinates": [
          [
            [
              102.21746372078178,
              6.398391432926061
            ],
            [
              101.76904431366881,
              5.811376670366343
            ],
            [
              100.98915184213337,
              5.724719467097856
            ],
            [
              101.14254541949833,
              6.208279394674321
            ],
            [
              100.24977241668779,
              6.710506438799385
            ],
            [
              99.97380968500732,
              6.346636961662071
            ],
            [
              99.93275302937576,
              5.0160165589699375
            ],
            [
              100.68668827507832,
              3.0545988187074755
            ],
            [
              102.01646592842678,
              1.95608798126689
            ],
            [
              103.18753561568246,
              1.491328633235483
            ],
            [
              104.37602118254483,
              1.731494427185993
            ],
            [
              104.4280609924831,
              3.6949966123298026
            ],
            [
              103.6032550858585,
              6.398374367320727
            ],
            [
              102.21746372078178,
              6.398391432926061
            ]
          ]
        ],
        "type": "Polygon"
      }
    }
  ]
}